import { render } from "./OtpModal.vue?vue&type=template&id=4a506341&scoped=true"
import script from "./OtpModal.vue?vue&type=script&lang=js"
export * from "./OtpModal.vue?vue&type=script&lang=js"

import "./OtpModal.vue?vue&type=style&index=0&id=4a506341&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a506341"]])

export default __exports__